"use client";

import React from "react";
import { BookOpen, Lightbulb, Target, TrendingUp } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const milestones = [{
  id: 1,
  date: "Fall Semester",
  title: "Strategic Management Research",
  description: "Engaged in rigorous research analyzing real-world corporate case studies to identify sustainable competitive advantages and market positioning strategies.",
  icon: BookOpen,
  collaborators: [{
    initials: "Dr. S",
    name: "Faculty Advisor",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/faculty_advisor.png"
  }, {
    initials: "JD",
    name: "Research Partner",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/research_partner.png"
  }]
}, {
  id: 2,
  date: "Spring Semester",
  title: "Entrepreneurial Innovation Initiative",
  description: "Collaborated on campus initiatives bridging theoretical frameworks with practical applications for scaling startups within the Chicago business ecosystem.",
  icon: Lightbulb,
  collaborators: [{
    initials: "Prof. M",
    name: "Initiative Lead",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/initiative_lead.png"
  }]
}, {
  id: 3,
  date: "Summer Practicum",
  title: "Data-Driven Business Solutions",
  description: "Leveraged advanced analytical tools to solve complex business challenges, refining expertise in quantitative analysis for corporate strategy.",
  icon: TrendingUp,
  collaborators: [{
    initials: "AT",
    name: "Data Analyst",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/data_analyst.png"
  }, {
    initials: "MR",
    name: "Strategy Consultant",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/strategy_consultant.png"
  }, {
    initials: "KL",
    name: "Project Manager",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/project_manager.png"
  }]
}];
const currentFocus = ["Synthesizing data-driven insights for capstone project.", "Building a professional network within the Chicago business community.", "Preparing for a dynamic career in consulting."];
export default function Loyola() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: timelineRef,
    isVisible: isTimelineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: focusRef,
    isVisible: isFocusVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}